export default __webpack_public_path__ + "static/media/Number_3_selected.db9115bd.svg";